import axios from "axios";
import {history} from 'home'

// const
const REDIRECT_TO_MODULE_EDIT = "moduleEdit/REDIRECT_TO_MODULE_EDIT";
const MODULE_EDIT_UPDATE_DATA = "moduleEdit/MODULE_EDIT_UPDATE_DATA";
const MODULE_EDIT_STORE_APPLICATION_TERMINALS = "applicationAdd/MODULE_EDIT_STORE_APPLICATION_TERMINALS";
const MODULE_EDIT_STORE_APPLICATION_MODELS = "applicationAdd/MODULE_EDIT_STORE_APPLICATION_MODELS";
const MODULE_EDIT_STORE_APPLICATION_TYPES = "applicationAdd/MODULE_EDIT_STORE_APPLICATION_TYPES";
const MODULE_EDIT_STORE_APPLICATION_CATEGORY_TREE = "moduleEdit/MODULE_EDIT_STORE_APPLICATION_CATEGORY_TREE";
const MODULE_EDIT_STORE_NAMESPACES = "moduleEdit/MODULE_EDIT_STORE_NAMESPACES";
const MODULE_EDIT_STORE_APPLICATION = "moduleEdit/MODULE_EDIT_STORE_APPLICATION";
const MODULE_EDIT_STORE_MAJOR_VERSIONS = "moduleEdit/MODULE_EDIT_STORE_MAJOR_VERSIONS";
// const MODULE_EDIT_STORE_RESOURCES = "moduleEdit/MODULE_EDIT_STORE_RESOURCES";
const MODULE_EDIT_UPDATE_RESOURCES = "moduleEdit/MODULE_EDIT_UPDATE_RESOURCES";
const MODULE_EDIT_STORE_VERSION_STATUS = "moduleEdit/MODULE_EDIT_STORE_VERSION_STATUS";
const MODULE_EDIT_TOGGLE_LOADING = "moduleEdit/MODULE_EDIT_TOGGLE_LOADING";
const MODULE_EDIT_TOGGLE_MODAL = "moduleEdit/MODULE_EDIT_TOGGLE_MODAL";

//modal const
const MODULE_EDIT_MODAL_SUCCESS_TITLE = "scenes_Application_ModuleEdit_modal_success_title";
const MODULE_EDIT_MODAL_FAIL_TITLE = "scenes_Application_ModuleEdit_modal_fail_title";
//更新应用信息成功/失败
const MODULE_EDIT_MODAL_UPDATE_SUCCESS_CONTENT = "scenes_Application_ModuleEdit_modal_updateSuccess_content";
const MODULE_EDIT_MODAL_UPDATE_FAIL_CONTENT = "scenes_Application_ModuleEdit_modal_updateFail_content";
//更新应用状态成功/失败
const MODULE_EDIT_MODAL_UPDATE_STATUS_SUCCESS_CONTENT = "scenes_Application_ModuleEdit_modal_updateStatusSuccess_content";
const MODULE_EDIT_MODAL_UPDATE_STATUS_FAIL_CONTENT = "scenes_Application_ModuleEdit_modal_updateStatusFail_content";
//云部署成功/失败
const MODULE_EDIT_MODAL_DEPLOY_SUCCESS_CONTENT = "scenes_Application_ModuleEdit_modal_deploySuccess_content";
const MODULE_EDIT_MODAL_DEPLOY_FAIL_CONTENT = "scenes_Application_ModuleEdit_modal_deployFail_content";
//删除应用计划成功/失败
const MODULE_EDIT_MODAL_DELETE_PLAN_SUCCESS_CONTENT = "scenes_Application_ModuleEdit_modal_deletePlanSuccess_content";
const MODULE_EDIT_MODAL_DELETE_PLAN_FAIL_CONTENT = "scenes_Application_ModuleEdit_modal_deletePlanFail_content";
const MODULE_EDIT_MODAL_OK_LABEL = "scenes_Application_ModuleEdit_modal_OK_label";
const MODULE_EDIT_MODAL_RETURN_LABEL = "scenes_Application_ModuleEdit_modal_return_label";
const MODULE_EDIT_MODAL_YES_LABEL = "scenes_Application_ModuleEdit_modal_yes_label";
const MODULE_EDIT_MODAL_NO_LABEL = "scenes_Application_ModuleEdit_modal_no_label";

// reducer
export const moduleEdit = (state = {
  loading: false,
  flag: "",
  versionVisible: false,

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalVisitUrl: null,
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  applicationTerminals: [],
  applicationModels: [],
  applicationTypes: [],
  applicationCategoryTree: [],

  applicationId: "",
  application: {
    name: "",
    enName: "",
    logo: "",
    code: "",
    terminal: {id: "", name: ""},
    model: {id: "", name: ""},
    type: {id: "", name: ""},
    parentCategory: {id: "", name: ""},
    category: {id: "", name: ""},
    description: "",
    createUserName: "",
    createCompanyName: "",
    createDate: "",
    majorVersionList: [],
    resources: [],
  },
  majorVersions: [],
  resources: [],
  resourceId: "",
  deployInfo: [],
  namespaces: [],

  appStatusName: "",
  appStatusCode: "",

  isModifyApplication: false,
  logo: "",
  logoImage: [],
  visibleLogo: false,
  previewLogo: "",
  name: "",
  appCategory: [],
  description: "",

  docker: "",
}, action) => {
  switch (action.type) {
    case REDIRECT_TO_MODULE_EDIT:
      return {
        ...state,
        applicationId: action.data
      };
    case MODULE_EDIT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MODULE_EDIT_STORE_APPLICATION_TERMINALS:
      return {
        ...state,
        applicationTerminals: action.data
      };
    case MODULE_EDIT_STORE_APPLICATION_MODELS:
      return {
        ...state,
        applicationModels: action.data
      };
    case MODULE_EDIT_STORE_APPLICATION_TYPES:
      return {
        ...state,
        applicationTypes: action.data
      };
    case MODULE_EDIT_STORE_APPLICATION_CATEGORY_TREE:
      return {
        ...state,
        applicationCategoryTree: action.data
      };
    case MODULE_EDIT_STORE_NAMESPACES:
      return {
        ...state,
        namespaces: action.data
      };
    case MODULE_EDIT_STORE_APPLICATION:
      let resources = action.data.resources.filter(resource => {
        return resource.ifEnabled;
      });
      return {
        ...state,
        applicationId: action.data.id,
        application: action.data,
        appStatusCode: action.data.status.code,
        appStatusName: action.data.status.name,
        isModifyApplication: false,
        resources: resources,
        resourceId: resources.length > 0 ? resources[0].id : "",
        logo: "",
        logoImage: [],
        visibleLogo: false,
        previewLogo: "",
        versionVisible: false,
        name: action.data.name,
        description: action.data.description,
        category: [action.data.parentCategory.id, action.data.category.id],
        docker: "",
      };
    case MODULE_EDIT_STORE_MAJOR_VERSIONS:
      return {
        ...state,
        majorVersions: action.data
      };
    // case MODULE_EDIT_STORE_RESOURCES:
    //   return {
    //     ...state,
    //     resources: action.data,
    //     resourceId: action.data.length > 0 ? action.data[0].id : "",
    //   };
    case MODULE_EDIT_UPDATE_RESOURCES:
      resources = state.resources.filter(resource => {
        return resource.id !== action.data
      });
      return {
        ...state,
        resources: resources,
        resourceId: resources.length > 0 ? resources[0].id : "",
      };
    case MODULE_EDIT_STORE_VERSION_STATUS: {
      state.application.majorVersionList.forEach(majorVersion => {
        majorVersion.minorVersionList.forEach(minorVersion => {
          if (minorVersion.id === action.data.id) {
            minorVersion.status = action.data.status
          }
        })
      });
      return {
        ...state,
      };
    }
    case MODULE_EDIT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case MODULE_EDIT_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalVisitUrl: action.data.modalVisitUrl || null,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    default:
      return state
  }
};

/**
 * 前页跳转此页，需要传递参数：application.id、application.name
 */
export function redirectToAppMainPage(applicationId) {
  return {
    type: REDIRECT_TO_MODULE_EDIT,
    data: applicationId
  };
}

/**
 * update data based on user input
 */
export const updateModuleEditData = (data) => {
  return {
    type: MODULE_EDIT_UPDATE_DATA,
    data: data
  }
};

/**
 * get all namespace
 */
export const getNamespaces = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-tenant/namespace/getNamespacesForMainApp", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeNamespaces(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all namespace
 */
export const storeNamespaces = (namespaces) => {
  return {
    type: MODULE_EDIT_STORE_NAMESPACES,
    data: namespaces
  }
};

/**
 * check application and get majorVersions
 */
export const initModuleEdit = (data) => (dispatch) => {
  let applicationId = data.applicationId;
  dispatch(updateModuleEditData({
    name: "flag",
    value: data.flag
  }));
  if (applicationId !== null && applicationId !== undefined && applicationId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-application/getApplication/${applicationId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeApplication(response.data));
          //   axios.get(`/api-application/getMajorVersionByApplicationId/${applicationId}`, {contentType: "application/json"}).then(
          //     response => {
          //       if (response.data) {
          //         dispatch(storeMajorVersions(response.data));
          //       }
          //     }
          //   );
          //   axios.get(`/api-application/applicationPlans/search/applicationId?applicationId=${applicationId}`, {contentType: "application/json"}).then(
          //     response => {
          //       if (response.data) {
          //         dispatch(storeResources(response.data._embedded.applicationPlans));
          //       }
          //     }
          //   );
          dispatch(toggleLoading(false));
        } else {
          dispatch(toggleLoading(false));
          history.push("/exception/415");
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    history.push("/exception/415");
  }
};

/**
 * store application
 */
export const storeApplication = (application) => {
  return {
    type: MODULE_EDIT_STORE_APPLICATION,
    data: application
  }
};
/**
 * store all major versions
 */
export const storeMajorVersions = (majorVersions) => {
  return {
    type: MODULE_EDIT_STORE_MAJOR_VERSIONS,
    data: majorVersions
  }
};

// /**
//  * store all resources
//  */
// export const storeResources = (resources) => {
//   return {
//     type: MODULE_EDIT_STORE_RESOURCES,
//     data: resources
//   }
// };

/**
 * submit data
 */
export const updateApplication = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-application/updateApplication`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.applicationId,
      "code": data.code,
      "name": data.name,
      "enName": data.enName,
      "logo": data.logo || "",
      "terminal": {"id": data.terminal},
      "model": {"id": data.model},
      "type": {"id": data.type},
      "parentCategory": {"id": data.category[0]},
      "category": {"id": data.category[1]},
      "status": {"code": data.appStatus},
      "description": data.description,
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success update application");
        dispatch(initModuleEdit(data));
        dispatch(updateModuleEditData({
          name: "isModifyApplication",
          value: false
        }));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: MODULE_EDIT_MODAL_UPDATE_SUCCESS_CONTENT,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_YES_LABEL,
          modalCancel: MODULE_EDIT_MODAL_NO_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            dispatch(updateApplicationStatus({
              applicationId: data.applicationId,
              appStatus: "1"
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          }
        }));

      } else {
        console.error("fail to update application");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_FAIL_TITLE,
          modalContent: MODULE_EDIT_MODAL_UPDATE_FAIL_CONTENT,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * find docker
 */
export const findDocker = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "POST",
    url: `/api-tenant/app/findDocker`,
    data: data,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200 && response.data) {
        console.info("success find docker");
        dispatch(updateModuleEditData({
          name: "docker",
          value: response.data
        }));
      } else {
        console.warn("no find docker");
        dispatch(updateModuleEditData({
          name: "docker",
          value: ""
        }));
      }
    }
  ).catch(
    err => {
      dispatch(toggleLoading(false))
      console.error("fail to find docker", err);
      dispatch(updateModuleEditData({
        name: "docker",
        value: ""
      }));
    }
  );
};

/**
 * submit deploy
 */
export const submitDeploy = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "POST",
    url: `/api-tenant/app/deploy`,
    data: data,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success deploy application");
        dispatch(updateModuleEditData({
          name: "versionVisible",
          value: false
        }));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: MODULE_EDIT_MODAL_DEPLOY_SUCCESS_CONTENT,
          modalVisitUrl: response.data,
          modalOk: MODULE_EDIT_MODAL_YES_LABEL,
          modalCancel: MODULE_EDIT_MODAL_NO_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
          }
        }));
      } else {
        console.error("fail to deploy application");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_FAIL_TITLE,
          modalContent: MODULE_EDIT_MODAL_DEPLOY_FAIL_CONTENT,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * update appStatus
 */
export const updateApplicationStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-application/updateApplicationStatus`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.applicationId,
      "status": {"code": data.appStatus},
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success application status");
        dispatch(updateModuleEditData({
          name: "appStatusCode",
          value: response.data.statusCode
        }));
        dispatch(updateModuleEditData({
          name: "appStatusName",
          value: response.data.statusName
        }));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: MODULE_EDIT_MODAL_UPDATE_STATUS_SUCCESS_CONTENT + data.appStatus,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_FAIL_TITLE,
          modalContent: MODULE_EDIT_MODAL_UPDATE_STATUS_FAIL_CONTENT + data.appStatus,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }

      // axios.post("/api-application/sendAppMessage", {
      //   id: data.applicationId,
      //   appStatus: {code: data.appStatus},
      // }).then(
      //   response => {
      //     if (response.status === 200) {
      //       //dispatch(showSuccessModal(true));
      //       console.log("success update app status");
      //     } else {
      //     //  dispatch(showFailModal(true));
      //       console.log("fail to update app status");
      //     }
      //   }
      // );
    }
  );
};

/**
 * store version status
 */
export const storeVersionStatus = (versionStatus) => {
  return {
    type: MODULE_EDIT_STORE_VERSION_STATUS,
    data: versionStatus
  }
};

/**
 * update version status
 */
export const updateVersionStatus = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "PUT",
    url: `/api-application/updateVersionStatus`,
    contentType: "application/json",
    withCredentials: true,
    data: {
      "id": data.id,
      "status": {"code": data.code},
    },
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success version status");
        dispatch(storeVersionStatus({
          id: data.id,
          status: response.data
        }));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: MODULE_EDIT_MODAL_UPDATE_STATUS_SUCCESS_CONTENT + data.code,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_FAIL_TITLE,
          modalContent: MODULE_EDIT_MODAL_UPDATE_STATUS_FAIL_CONTENT + data.code,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }

      // axios.post("/api-application/sendAppMessage", {
      //   id: data.applicationId,
      //   appStatus: {code: data.appStatus},
      // }).then(
      //   response => {
      //     if (response.status === 200) {
      //       //dispatch(showSuccessModal(true));
      //       console.log("success update app status");
      //     } else {
      //     //  dispatch(showFailModal(true));
      //       console.log("fail to update app status");
      //     }
      //   }
      // );
    }
  );
};

/**
 * delete resource
 */
export const deleteResource = (data) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios({
    method: "DELETE",
    url: `/api-application/deleteResource/${data.resourceId}`,
    contentType: "application/json",
    withCredentials: true,
  }).then(
    response => {
      dispatch(toggleLoading(false));
      if (response.status === 200) {
        console.info("success delete resources");
        dispatch(updateResources(data.resourceId));
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_SUCCESS_TITLE,
          modalContent: MODULE_EDIT_MODAL_DELETE_PLAN_SUCCESS_CONTENT,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      } else {
        console.error("fail to delete resource");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: MODULE_EDIT_MODAL_FAIL_TITLE,
          modalContent: MODULE_EDIT_MODAL_DELETE_PLAN_FAIL_CONTENT,
          modalVisitUrl: null,
          modalOk: MODULE_EDIT_MODAL_OK_LABEL,
          modalCancel: MODULE_EDIT_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
      }
    }
  );
};

/**
 * update resources
 */
export const updateResources = (resourceId) => {
  return {
    type: MODULE_EDIT_UPDATE_RESOURCES,
    data: resourceId
  }
};

/**
 * toggle modal
 */
export const toggleLoading = (show) => {
  return {
    type: MODULE_EDIT_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: MODULE_EDIT_TOGGLE_MODAL,
    data: show
  }
};

/***
 * empty function
 * @param id
 */
export const deleteModule = (id) => {

}
